import _classCallCheck from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * This is a helper class to construct a string representing the permissions granted by a ServiceSAS to a container.
 * Setting a value to true means that any SAS which uses these permissions will grant permissions for that operation.
 * Once all the values are set, this should be serialized with toString and set as the permissions field on a
 * {@link BlobSASSignatureValues} object. It is possible to construct the permissions string without this class, but
 * the order of the permissions is particular and this class guarantees correctness.
 */
export var ContainerSASPermissions = /*#__PURE__*/function () {
  function ContainerSASPermissions() {
    _classCallCheck(this, ContainerSASPermissions);

    /**
     * Specifies Read access granted.
     */
    this.read = false;
    /**
     * Specifies Add access granted.
     */

    this.add = false;
    /**
     * Specifies Create access granted.
     */

    this.create = false;
    /**
     * Specifies Write access granted.
     */

    this.write = false;
    /**
     * Specifies Delete access granted.
     */

    this.delete = false;
    /**
     * Specifies Delete version access granted.
     */

    this.deleteVersion = false;
    /**
     * Specifies List access granted.
     */

    this.list = false;
    /**
     * Specfies Tag access granted.
     */

    this.tag = false;
    /**
     * Specifies Move access granted.
     */

    this.move = false;
    /**
     * Specifies Execute access granted.
     */

    this.execute = false;
    /**
     * Specifies SetImmutabilityPolicy access granted.
     */

    this.setImmutabilityPolicy = false;
    /**
     * Specifies that Permanent Delete is permitted.
     */

    this.permanentDelete = false;
    /**
     * Specifies that Filter Blobs by Tags is permitted.
     */

    this.filterByTags = false;
  }
  /**
   * Creates an {@link ContainerSASPermissions} from the specified permissions string. This method will throw an
   * Error if it encounters a character that does not correspond to a valid permission.
   *
   * @param permissions -
   */


  _createClass(ContainerSASPermissions, [{
    key: "toString",
    value:
    /**
     * Converts the given permissions to a string. Using this method will guarantee the permissions are in an
     * order accepted by the service.
     *
     * The order of the characters should be as specified here to ensure correctness.
     * @see https://docs.microsoft.com/en-us/rest/api/storageservices/constructing-a-service-sas
     *
     */
    function toString() {
      var permissions = [];

      if (this.read) {
        permissions.push("r");
      }

      if (this.add) {
        permissions.push("a");
      }

      if (this.create) {
        permissions.push("c");
      }

      if (this.write) {
        permissions.push("w");
      }

      if (this.delete) {
        permissions.push("d");
      }

      if (this.deleteVersion) {
        permissions.push("x");
      }

      if (this.list) {
        permissions.push("l");
      }

      if (this.tag) {
        permissions.push("t");
      }

      if (this.move) {
        permissions.push("m");
      }

      if (this.execute) {
        permissions.push("e");
      }

      if (this.setImmutabilityPolicy) {
        permissions.push("i");
      }

      if (this.permanentDelete) {
        permissions.push("y");
      }

      if (this.filterByTags) {
        permissions.push("f");
      }

      return permissions.join("");
    }
  }], [{
    key: "parse",
    value: function parse(permissions) {
      var containerSASPermissions = new ContainerSASPermissions();

      var _iterator = _createForOfIteratorHelper(permissions),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var char = _step.value;

          switch (char) {
            case "r":
              containerSASPermissions.read = true;
              break;

            case "a":
              containerSASPermissions.add = true;
              break;

            case "c":
              containerSASPermissions.create = true;
              break;

            case "w":
              containerSASPermissions.write = true;
              break;

            case "d":
              containerSASPermissions.delete = true;
              break;

            case "l":
              containerSASPermissions.list = true;
              break;

            case "t":
              containerSASPermissions.tag = true;
              break;

            case "x":
              containerSASPermissions.deleteVersion = true;
              break;

            case "m":
              containerSASPermissions.move = true;
              break;

            case "e":
              containerSASPermissions.execute = true;
              break;

            case "i":
              containerSASPermissions.setImmutabilityPolicy = true;
              break;

            case "y":
              containerSASPermissions.permanentDelete = true;
              break;

            case "f":
              containerSASPermissions.filterByTags = true;
              break;

            default:
              throw new RangeError("Invalid permission ".concat(char));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return containerSASPermissions;
    }
    /**
     * Creates a {@link ContainerSASPermissions} from a raw object which contains same keys as it
     * and boolean values for them.
     *
     * @param permissionLike -
     */

  }, {
    key: "from",
    value: function from(permissionLike) {
      var containerSASPermissions = new ContainerSASPermissions();

      if (permissionLike.read) {
        containerSASPermissions.read = true;
      }

      if (permissionLike.add) {
        containerSASPermissions.add = true;
      }

      if (permissionLike.create) {
        containerSASPermissions.create = true;
      }

      if (permissionLike.write) {
        containerSASPermissions.write = true;
      }

      if (permissionLike.delete) {
        containerSASPermissions.delete = true;
      }

      if (permissionLike.list) {
        containerSASPermissions.list = true;
      }

      if (permissionLike.deleteVersion) {
        containerSASPermissions.deleteVersion = true;
      }

      if (permissionLike.tag) {
        containerSASPermissions.tag = true;
      }

      if (permissionLike.move) {
        containerSASPermissions.move = true;
      }

      if (permissionLike.execute) {
        containerSASPermissions.execute = true;
      }

      if (permissionLike.setImmutabilityPolicy) {
        containerSASPermissions.setImmutabilityPolicy = true;
      }

      if (permissionLike.permanentDelete) {
        containerSASPermissions.permanentDelete = true;
      }

      if (permissionLike.filterByTags) {
        containerSASPermissions.filterByTags = true;
      }

      return containerSASPermissions;
    }
  }]);

  return ContainerSASPermissions;
}();